import { useSelector } from 'react-redux';

import { config } from '../../../../config/config';
import { useGetBannerCollectionsQuery } from '../../queries/banners.graphql';
import { selectLocale } from '../../store/locale.store';
import { Carousel } from '../carousel/carousel';
import { Loader } from '../loader/loader';
import type { SlideType } from '../slide/slide.interface';

export interface IBannerCollectionProps {
    className?: string;
    page: string;
    type?: SlideType;
}

export const BannerCollection: ({
    className,
    page,
    type,
}: {
    className?: any;
    page: any;
    type: any;
}) => JSX.Element | null = ({ className, page, type }) => {
    const locale = useSelector(selectLocale);

    const [{ data: collections, fetching }] = useGetBannerCollectionsQuery({
        variables: {
            xTenantID: config.TENANT_ID,
            locale: locale,
            skinId: config.SKIN_ID,
        },
    });

    if (fetching || !collections) {
        return <Loader />;
    }

    const bannersForPage = collections.getBannerCollections.find(({ pages }) =>
        pages.includes(page),
    );
    console.log(bannersForPage);
    if (!bannersForPage) {
        return null;
    }

    return <Carousel className={className} collection={bannersForPage} type={type} />;
};
